import { Fragment, useEffect, useState } from "react";
// for work_images
import assistivLabs from "../assets/images/work_images/assistivlabs.webp";
import realLINGUA from "../assets/images/work_images/realLINGUA.png";
import threshold from "../assets/images/work_images/threshold.png";
import splitter from "../assets/images/work_images/splitter.png";
import virtualChoirMixer from "../assets/images/work_images/virtualchoirmixer.png";
// works small images
import assistivLabsSmall from "../assets/images/work_images/small/assistivlabs.png";
import realLINGUAsmall from "../assets/images/work_images/small/realLINGUA.png";
import ryan from "../assets/images/work_images/small/ryan-cook.jpeg";
import splitterSmall from "../assets/images/work_images/small/splitter.png";
import virtualChoirMixerSmall from "../assets/images/work_images/small/UMMGC.jpeg";
// blog post images
// import blog6 from '../assets/images/blog_images/6.jpg';
// import blog4 from '../assets/images/blog_images/4.jpg';
// import blog2 from '../assets/images/blog_images/2.jpg';
// import blog1 from '../assets/images/blog_images/1.jpg';
// import blog3 from '../assets/images/blog_images/3.jpg';
// import blog5 from '../assets/images/blog_images/5.jpg';
// blog image small
// import blogSmall6 from '../assets/images/blog_images/small/6.jpg';
// import blogSmall4 from '../assets/images/blog_images/small/4.jpg';
// import blogSmall2 from '../assets/images/blog_images/small/2.jpg';
// import blogSmall1 from '../assets/images/blog_images/small/1.jpg';
// import blogSmall3 from '../assets/images/blog_images/small/3.jpg';
// import blogSmall5 from '../assets/images/blog_images/small/5.jpg';

import img1 from "../assets/images/slider/brand.png";
import img2 from "../assets/images/slider/brand (1).png";
import img3 from "../assets/images/slider/brand (2).png";
import img4 from "../assets/images/slider/brand (3).png";
import img5 from "../assets/images/slider/brand (4).png";
//  icon use as img here
// import icon from '../assets/images/icons/icon.svg';
import icon1 from "../assets/images/icons/icon (1).svg";
// import icon2 from '../assets/images/icons/icon (2).svg';
// import guitar from '../assets/images/icons/guitar-solid.svg';
// import icon3 from '../assets/images/icons/icon (3).svg';
import icon4 from "../assets/images/icons/icon (4).svg";
import icon5 from "../assets/images/icons/icon (5).svg";
// contact image
import iconPhone from "../assets/images/contact/phone-call 1.png";
import iconEmail from "../assets/images/contact/email 1.png";
import iconMap from "../assets/images/contact/map 1.png";
import { CgNotes } from "react-icons/cg";
import { FaBlogger, FaRegUser, FaAward, FaMusic } from "react-icons/fa";
import { AiOutlineHome } from "react-icons/ai";
import { FiCodesandbox } from "react-icons/fi";
import { RiContactsBookLine } from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";

import { MdOutlineBusinessCenter, MdOutlineSchool } from "react-icons/md";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGuitar } from "@fortawesome/free-solid-svg-icons";

const AllData = () => {
  const [check, setCheck] = useState(false);
  const [local, setLocal] = useState(localStorage.getItem("theme"));
  const [singleData, setSingleData] = useState({});
  const [isOpen, setIsOpen] = useState(false);

  // dark and light theme controls
  useEffect(() => {
    const themeValue = localStorage?.getItem("theme");

    if (!themeValue) {
      setCheck(false);
      localStorage.setItem("theme", "light");
    } else {
      themeValue === "dark" && setCheck(true);
      themeValue === "light" && setCheck(false);
    }

    localStorage?.getItem("theme") === "dark"
      ? document.documentElement.classList.add("dark")
      : document.documentElement.classList.remove("dark");
  }, []);

  // Create and light theme function
  const handleTheme = (value) => {
    if (value === "light") {
      setCheck(false);
      localStorage.setItem("theme", "light");
      setLocal("light");
    } else {
      setCheck(true);
      localStorage.setItem("theme", "dark");
      setLocal("dark");
    }
    localStorage?.getItem("theme") === "dark"
      ? document.documentElement.classList.add("dark")
      : document.documentElement.classList.remove("dark");
  };

  // fillter portfilo data
  const handleData = (text) => {
    if (text === "All") {
      setData(workItems);
    } else {
      const findData = workItems.filter((item) => item.tag === text);
      setData(findData);
    }
  };

  // find items for portfilo  modal open
  const handleModelData = (id) => {
    const find = workItems.find((item) => item?.id === id);
    setSingleData(find);
    setIsOpen(true);
  };

  // find items for Blogs  modal open
  const handleBlogsData = (id) => {
    const find = blogsData.find((item) => item?.id === id);
    setSingleData(find);
    setIsOpen(true);
  };

  // find items for Music  modal open
  const handleMusicData = (id) => {
    const find = musicData.find((item) => item?.id === id);
    setSingleData(find);
    setIsOpen(true);
  };

  // Active navlinks function
  function NavLink({
    to,
    className,
    activeClassName,
    inactiveClassName,
    ...rest
  }) {
    let location = useLocation();
    let isActive = location.pathname === to;
    let allClassNames =
      className + (isActive ? `${activeClassName}` : `${inactiveClassName}`);
    return <Link className={allClassNames} to={to} {...rest} />;
  }

  // Elements for protfilo section
  const workItems = [
    {
      id: "1",
      tag: "Full Time",
      title: "Software Engineer",
      img: assistivLabs,
      imgSmall: assistivLabsSmall,
      bg: "#F8FFF0",
      client: "Assistiv Labs",
      langages: "JavaScript, Powershell",
      link: "https://www.assistivlabs.com",
      linkText: "assistivlabs.com",
      description:
        "As a software engineer at Assistiv Labs, I work to create tools for developers to test the accessibility on their websites with the real assistive technologies that users rely on. I use JavaScript mainly, and a few other language to develop and maintain web applications that integrate with screen readers, magnifiers, and other devices. I also contribute to the user interface design, documentation, and testing of the products.",
    },
    {
      id: "2",
      tag: "Project Work",
      title: "reaLINGUA",
      img: realLINGUA,
      imgSmall: realLINGUAsmall,
      bg: "#FFF0F0",
      client: "realLINGUA",
      langages: "JavaScript, React",
      link: "https://www.reallingua.com",
      linkText: "reallingua.com",
      description:
        "After joining the team as a front-end intern, I quickly started contributing to the project with lots of efficient, meaningful pull requests. When the CTO had to leave the position, I was then promoted to CTO and helped facilitate the refactor process to a clean React frontend with a MongoDB database.",
    },
    {
      id: "3",
      tag: "Freelance",
      title: "threshold poem",
      img: threshold,
      imgSmall: ryan,
      bg: "#FFF3FC",
      client: "Ryan Patrick Cook",
      langages: "HTML, CSS, JavaScript",
      link: "https://threshold-poem.github.io/",
      linkText: "threshold-poem.github.io",
      description:
        "Working with the poet Ryan Cook, I helped them create a website to showcase their special interactive poem.",
    },
    {
      id: "4",
      tag: "Project Work",
      title: "splitter.fm",
      img: splitter,
      imgSmall: splitterSmall,
      bg: "#FFFAE9",
      client: "splitter.fm",
      langages: "Ruby, React",
      link: "https://splitter.fm/",
      linkText: "splitter.fm",
      description:
        "A program to listen to the individual stems of published albums all in the browser. Joined the team to help with general programming and bug squashing, while prepping for new changes rolling out soon.",
    },
    {
      id: "5",
      tag: "Personal",
      title: "Virtual Choir Mixer",
      img: virtualChoirMixer,
      imgSmall: virtualChoirMixerSmall,
      bg: "#E9FAFF",
      client: "Personal Project",
      langages: "Javascript, HTML",
      link: "https://nickcook.vercel.app/virtual-choir-mixer/",
      linkText: "nickcook.vercel.app/virtual-choir-mixer/",
      description:
        "At the beginning of the Coronavirus pandemic, one of the first things to disappear was my favorite organization and pastime: the University of Michigan Men's Glee Club. Since singing required you to be in close spaces with each other, it was not safe, so everyone in choirs everywhere started to release videos of virtual choirs, which were individual recorded videos all stitched together. We made a lot of these with UMMGC, and they all took a tremendous amount of work each time. To help facilitate the process, I made this small tool so that you could easily record your video and have it automatically be synced up exactly with the practice track, and everyone else's videos. ",
    },
    // {
    //   id: '5',
    //   tag: 'UI/UX',
    //   title: 'Chul urina',
    //   img: work5,
    //   imgSmall: workSmall5,
    //   bg: '##FFF0F0',
    //   client: 'Envato',
    //   langages: 'Photoshop',
    //   link: 'https://www.envato.com',
    //   linkText: 'www.envato.com',
    //   description:
    //     '  Lorem ipsum dolor sit amet consectetur, adipisicing elit. Cupiditate non suscipit voluptatibus minima ullam maiores sequi nihil placeat error, vero eaque doloremque reiciendis amet pariatur consequuntur. Nostrum, dolore, amet eligendi ipsam enim quisquam, corrupti asperiores nihil excepturi aspernatur placeat iure.',
    // },
    // {
    //   id: '6',
    //   tag: 'Video',
    //   title: 'Chul urina',
    //   img: work6,
    //   imgSmall: workSmall6,
    //   bg: '#F4F4FF',
    //   client: 'Envato',
    //   langages: 'Vimeo',
    //   link: 'https://www.envato.com',
    //   linkText: 'www.envato.com',
    //   description:
    //     '  Lorem ipsum dolor sit amet consectetur, adipisicing elit. Cupiditate non suscipit voluptatibus minima ullam maiores sequi nihil placeat error, vero eaque doloremque reiciendis amet pariatur consequuntur. Nostrum, dolore, amet eligendi ipsam enim quisquam, corrupti asperiores nihil excepturi aspernatur placeat iure.',
    // },
    // {
    //   id: '7',
    //   tag: 'UI/UX',
    //   title: 'Chul urina',
    //   img: work7,
    //   imgSmall: workSmall7,
    //   bg: '#FFF0F8',
    //   client: 'Envato',
    //   langages: 'Photoshop',
    //   link: 'https://www.envato.com',
    //   linkText: 'www.envato.com',
    //   description:
    //     '  Lorem ipsum dolor sit amet consectetur, adipisicing elit. Cupiditate non suscipit voluptatibus minima ullam maiores sequi nihil placeat error, vero eaque doloremque reiciendis amet pariatur consequuntur. Nostrum, dolore, amet eligendi ipsam enim quisquam, corrupti asperiores nihil excepturi aspernatur placeat iure.',
    // },
    // {
    //   id: '8',
    //   tag: 'Web Design',
    //   title: 'Chul urina',
    //   img: work8,
    //   imgSmall: workSmall8,
    //   bg: '#FFF0F8',
    //   client: 'Envato',
    //   langages: 'HTML, CSS, Javascript',
    //   link: 'https://www.envato.com',
    //   linkText: 'www.envato.com',
    //   description:
    //     '  Lorem ipsum dolor sit amet consectetur, adipisicing elit. Cupiditate non suscipit voluptatibus minima ullam maiores sequi nihil placeat error, vero eaque doloremque reiciendis amet pariatur consequuntur. Nostrum, dolore, amet eligendi ipsam enim quisquam, corrupti asperiores nihil excepturi aspernatur placeat iure.',
    // },
    // {
    //   id: '9',
    //   tag: 'Logo',
    //   title: 'Chul urina',
    //   img: work9,
    //   imgSmall: workSmall9,
    //   bg: '#FCF4FF',
    //   client: 'Feepik',
    //   langages: 'Figma',
    //   link: 'https://www.freepik.com/free-photos-vectors/market-logo',
    //   linkText: 'www.freepik.com',
    //   description:
    //     '  Lorem ipsum dolor sit amet consectetur, adipisicing elit. Cupiditate non suscipit voluptatibus minima ullam maiores sequi nihil placeat error, vero eaque doloremque reiciendis amet pariatur consequuntur. Nostrum, dolore, amet eligendi ipsam enim quisquam, corrupti asperiores nihil excepturi aspernatur placeat iure.',
    // },
  ];
  const [data, setData] = useState(workItems);

  // Elements for Blogs section
  const blogsData = [
    // {
    //   id: '1',
    //   img: blog1,
    //   imgSmall: blogSmall1,
    //   date: '177 April',
    //   category: 'Inspiration',
    //   title: 'How to Own Your Audience by Creating an Email List.',
    //   bg: '#FCF4FF',
    //   description:
    //     'Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum conseqr quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consetur quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. ',
    // },
    // {
    //   id: '4',
    //   img: blog4,
    //   imgSmall: blogSmall4,
    //   date: '000 April',
    //   category: 'Inspiration',
    //   title: 'Everything You Need to Know About Web Accessibility.',
    //   bg: '#EEFBFF',
    //   description:
    //     'Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum conseqr quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consetur quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. ',
    // },
    // {
    //   id: '2',
    //   img: blog2,
    //   imgSmall: blogSmall2,
    //   date: '21 April',
    //   category: 'Web Design',
    //   title: 'The window know to say beside you',
    //   bg: '#FFF0F0',
    //   description:
    //     'Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum conseqr quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consetur quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. ',
    // },
    // {
    //   id: '5',
    //   img: blog5,
    //   imgSmall: blogSmall5,
    //   date: '27 April',
    //   category: 'Inspiration',
    //   title: 'Top 10 Toolkits for Deep Learning in 2021.',
    //   bg: '#FCF4FF',
    //   description:
    //     'Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum conseqr quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consetur quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. ',
    // },
    // {
    //   id: '3',
    //   img: blog3,
    //   imgSmall: blogSmall3,
    //   date: '27 April',
    //   category: 'Inspiration',
    //   title: 'How to Own Your Audience by Creating an Email List.',
    //   bg: '#FCF4FF',
    //   description:
    //     'Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum conseqr quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consetur quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. ',
    // },
    // {
    //   id: '6',
    //   img: blog6,
    //   imgSmall: blogSmall6,
    //   date: '27 April',
    //   category: 'Inspiration',
    //   title: 'Everything You Need to Know About Web Accessibility.',
    //   bg: '#EEFBFF',
    //   description:
    //     'Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum conseqr quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consetur quo obcaecati rerum sit non. Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur. \n Lorem ipsum dolor, sit amet consectetur adipisicing  elit. Fuga consequatur delectus porro sapiente molestias, magni quasi sed, enim corporis omnis doloremque soluta inventore dolorum consequuntur quo obcaecati rerum sit non. ',
    // },
  ];
  const musicData = [];

  // Menu items for Homepage One
  const menuItem = [
    {
      id: "01",
      name: "Home",
      link: "/home/homePage",
      icon: <AiOutlineHome />,
    },
    {
      id: "02",
      name: "About",
      link: "/home/about",
      icon: <FaRegUser />,
    },
    {
      id: "06",
      name: "Resume",
      link: "/home/resume",
      icon: <CgNotes />,
    },
    {
      id: "03",
      name: "Works",
      link: "/home/works",
      icon: <FiCodesandbox />,
    },
    {
      id: "04",
      name: "Blogs",
      link: "/home/blogs",
      icon: <FaBlogger />,
    },
    {
      id: "05",
      name: "Contact",
      link: "/home/contact",
      icon: <RiContactsBookLine />,
    },
  ];

  // Menu items for Homepage Two
  const menuItemTwo = [
    {
      id: "01",
      name: "About",
      link: "/about",
      icon: <FaRegUser />,
    },
    {
      id: "02",
      name: "Resume",
      link: "/resume",
      icon: <CgNotes />,
    },
    {
      id: "03",
      name: "Works",
      link: "/works",
      icon: <FiCodesandbox />,
    },
    {
      id: "04",
      name: "Music",
      link: "/music",
      icon: <FaMusic />,
    },
    {
      id: "05",
      name: "Contact",
      link: "/contact",
      icon: <RiContactsBookLine />,
    },
  ];

  // Slider image for Clients
  const sliderImg = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img1,
    img2,
    img3,
    img4,
    img5,
  ];

  // Slider badges
  const sliderBadges = [
    {
      id: "f022e2d9-455a-40ea-9cd8-91ee3af6422f",
    },
    {
      id: "6392362f-3a1e-4e0e-9c17-3baa679ba6ba",
    },
    {
      id: "33b81206-2232-41fb-aa33-7209e7c36fdc",
    },
  ];

  // experience items for about page
  const experienceArray = [
    {
      id: "1",
      icon: icon5,
      title: "Web Development",
      des: "Create websites with beautiful frontends, and efficient backends.",
      color: "#D566FF",
      bg: "#FCF4FF",
    },
    {
      id: "2",
      icon: icon1,
      title: "Accessibility",
      des: "Ensure websites are fully accessible for screen readers and all users.",
      color: "#DDA10C",
      bg: "#FEFAF0",
    },
    {
      id: "3",
      FaIcon: <FontAwesomeIcon icon={faGuitar} color="#fc456d" size="3x" />,
      title: "Guitar",
      des: (
        <Fragment>
          Writing music and gigging with the band <i>Anytime</i>
        </Fragment>
      ),
      color: "#8774FF",
      bg: "#FCF4FF",
    },
    {
      id: "4",
      icon: icon4,
      title: "Side Projects",
      des: "I like making digital tools and side projects as a way to have fun and learn new programming frameworks.",
      color: "#FF6080",
      bg: "#FFF4F4",
    },
  ];

  // Resume items for Resume page
  const resumeArray = [
    {
      type: "Education",
      icon: MdOutlineSchool,
      items: [
        {
          id: "01",
          date: "2019 - 2023",
          title: "B.S. Computer Science",
          place: "University of Michigan, Ann Arbor",
          bg: "#FFF4F4",
        },
        {
          id: "02",
          date: "2019 - 2023",
          title: "B.S. Linguistics",
          place: "University of Michigan, Ann Arbor",
          bg: "#FFF1FB",
        },
        {
          id: "03",
          date: "2019 - 2023",
          title: "Minor in Spanish ",
          place: "University of Michigan, Ann Arbor",
          bg: "#FFF4F4",
        },
        {
          id: "03",
          date: "2019 - 2023",
          title: "Minor in Music ",
          place: "University of Michigan, Ann Arbor",
          bg: "#FFF1FB",
        },
      ],
    },
    {
      type: "Experience",
      icon: MdOutlineBusinessCenter,
      items: [
        {
          id: "03",
          date: "2022 - Present",
          title: "Software Engineer",
          place: "Assistiv Labs",
          bg: "#EEF5FA",
        },
        {
          id: "04",
          date: "2022",
          title: "Software Accessibility Intern",
          place: "American Foundation for the Blind",
          bg: "#F2F4FF",
        },
        {
          id: "06",
          date: "2020 - Present",
          title: "Freelance WebDev",
          place: "Independent Contractor",
          bg: "#EEF5FA",
        },
        {
          id: "05",
          date: "2020 - 2022",
          title: "CTO",
          place: "realLINGUA",
          bg: "#F2F4FF",
        },
      ],
    },
    {
      type: "Awards",
      icon: FaAward,
      id: "07",
      date: "2015-2017",
      title: "  Graphic Designer",
      place: "Web Graphy, Los Angeles, CA",
      bg: "#FCF4FF",

      id1: "08",
      date1: "2014 - 2015",
      title1: "Jr. Web Developer",
      place1: "Creative Gigs.",
      bg1: "#FCF9F2",

      id2: "09",
      date2: "2015-2017",
      title2: "Best Freelancer",
      place2: "Fiver & Upwork Level 2 & Top Rated",
      bg2: "#FCF4FF",
    },
  ];

  // Working Skills items for Resume page
  const lineArray = [
    {
      id: "01",
      color: "#FF6464",
      name: "Web Design",
      number: "80",
    },
    {
      id: "02",
      color: "#9272D4",
      name: "Mobile App ",
      number: "95",
    },
    {
      id: "03",
      color: "#5185D4",
      name: "Illustrator",
      number: "65",
    },
    {
      id: "03",
      color: "#CA56F2",
      name: "Photoshope",
      number: "75",
    },
  ];

  // Personal information for contact pages
  const contactArray = [
    {
      id: "01",
      icon: iconPhone,
      title: "Phone ",
      item1: "+452 666 386",
      item2: "+452 666 386",
      bg: "#FCF4FF",
    },
    {
      id: "02",
      icon: iconEmail,
      title: "Email ",
      item1: "support@gmail.com",
      item2: "example@gmail.com",
      bg: "#EEFBFF",
    },
    {
      id: "03",
      icon: iconMap,
      title: "Address ",
      item1: "Maount View, Oval",
      item2: "Road, New York, USA",
      bg: "#F2F4FF",
    },
  ];

  return {
    handleTheme,
    check,
    local,
    handleData,
    data,
    singleData,
    handleModelData,
    isOpen,
    setIsOpen,
    blogsData,
    handleBlogsData,
    musicData,
    handleMusicData,
    menuItem,
    NavLink,
    menuItemTwo,
    experienceArray,
    sliderImg,
    sliderBadges,
    resumeArray,
    lineArray,
    contactArray,
  };
};

export default AllData;
